@if (column.type == 'number') {
  <div class="n">
    {{ row[column.name]?.value }}
  </div>
}

@if (column.type == 'link') {
  <div class="c6">
    <a class="collection" (click)="openInNewWindow.emit({ url: row[column.name]?.value, event: $event })" href="">{{ column.linkName }}</a>
  </div>
}

@if (column.type == 'set') {
  @if ((column.showButtonField && row[column.showButtonField]?.value == true) || !column.showButtonField) {
    @if (column.name == 'PersonRecord' || column.name == 'AuthorizedSites') {
      @if (currentSet.tableDisplay?.entityName == 'Security.iOPSUser' || currentSet.tableDisplay?.entityName == 'Person' || currentSet.tableDisplay?.entityName == 'UserOrganization') {
        @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value == 1) {
          <button class="btn rdn-cell-btn mr-1" type="button" (click)="openSet.emit({ rowFieldData: row[column.name], event: $event })">
            {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
          </button>
        }
        @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value != 1) {
          <div style="z-index: 1" class="btn btn-link-icon">&nbsp;</div>
        }
      } @else {
        <button class="btn rdn-cell-btn mr-1" type="button" (click)="openSet.emit({ rowFieldData: row[column.name], event: $event })">
          {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
        </button>
      }
    } @else {
      <button class="btn rdn-cell-btn mr-1" type="button" (click)="openSet.emit({ rowFieldData: row[column.name], event: $event })">
        {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
      </button>

      @if (column.name == 'RecipeConditions' || column.name == 'RuleConditions') {
        @if (row['ConditionsInEnglish']?.value != null) {
          <div style="color: rgb(80, 151, 148); white-space: pre;" [title]="row['ConditionsWithDescriptionsInEnglish']?.value">{{row['ConditionsInEnglish']?.value}}</div>
        }
      }

      @if (column.name == 'ConditionWatches') {
        @if (row['ConditionWatchInEnglish']?.value != null) {
          <div style="color: rgb(80, 151, 148); white-space: pre;">{{row['ConditionWatchInEnglish']?.value}}</div>
        }
      }
    }
  }
}

@if (column.type == 'sendChangePasswordToken') {
  @if ((column.showButtonField && row[column.showButtonField]?.value == true) || !column.showButtonField) {
    @if (currentSet.tableDisplay?.entityName == 'Security.iOPSUser') {
      @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value == 1) {
        <button class="btn rdn-cell-btn mr-1" type="button" (click)="sendToken.emit({ username: row[column.field]?.value, event: $event })">
          {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
        </button>
      }
      @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value != 1) {
        &nbsp;
      }
    } @else {
      <button class="btn rdn-cell-btn mr-1" type="button" (click)="sendToken.emit({ username: row[column.field]?.value, event: $event })">
        {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
      </button>
    }
  }
}

@if (column.type == 'resetPassword') {
  @if ((column.showButtonField && row[column.showButtonField]?.value == true) || !column.showButtonField) {
    <button class="btn rdn-cell-btn mr-1" type="button" (click)="resetPassword.emit({ email: row['Email']?.value, username: row['Username']?.value, event: $event })">
      {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
    </button>
  }
}

@if (column.type == 'resetMFA') {
  @if ((column.showButtonField && row[column.showButtonField]?.value == true) || !column.showButtonField) {
    <button class="btn rdn-cell-btn mr-1" type="button" (click)="resetMFA.emit({ email: row['Email']?.value, username: row['Username']?.value, event: $event })">
      {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '')) : ''}}
    </button>
  }
}

@if (column.type == 'logInAs') {
  @if ((column.showButtonField && row[column.showButtonField]?.value == true) || !column.showButtonField) {
    <button class="btn rdn-cell-btn mr-1" type="button" (click)="logInAsUser.emit({ username: row[column.field]?.value, event: $event })">
      {{column.countOfRecordsField ? column.countOfRecordsFieldLabel + ' (' + (row[column.countOfRecordsField]?.value != null ? row[column.countOfRecordsField]?.value : 0) + ')' : ''}}{{!column.countOfRecordsField ? (column.buttonLabel != null ? (row[column.buttonLabel]?.value != null ? row[column.buttonLabel]?.value : column.buttonLabel) : (column.label ? column.label + (column.additionalLabelField != null ? ': ' + row[column.additionalLabelField]?.value : '') : 'Log In As')) : ''}}
    </button>
  }
}

@if (column.type == 'creator-user') {
  <div class="t">
    {{ row[column.name]?.value }}
    @if (row['CreationDate']?.value != null || row['creationDate']?.value != null) {
      <div style="color: rgb(149, 194, 192);">
        {{ (row['CreationDate']?.value != null ? row['CreationDate']?.value : row['creationDate']?.value) | date:'MM/dd/yyyy HH:mm:ss.SSS' }}
      </div>
    }
  </div>
}

@if (column.type == 'last-modified-user') {
  <div class="t">
    {{ row[column.name]?.value }}
    @if (row['LastModifiedDate']?.value != null || row['lastModifiedDate']?.value != null) {
      <div style="color: rgb(149, 194, 192);">
        {{ (row['LastModifiedDate']?.value != null ? row['LastModifiedDate']?.value : row['lastModifiedDate']?.value) | date:'MM/dd/yyyy HH:mm:ss.SSS' }}
      </div>
    }
  </div>
}

@if (column.type == 'requestor-user' && row['RequestedDateMS'] != null) {
  <div class="t">
    {{ row[column.name]?.value }}
    <div style="color: rgb(149, 194, 192);">{{row['RequestedDateMS'] | date:'MM/dd/yyyy HH:mm:ss.SSS'}}</div>
  </div>
}

@if (column.type == 'approver-user' && row['ApprovedDateMS'] != null) {
  <div class="t">
    {{ row[column.name]?.value }}
    <div style="color: rgb(149, 194, 192);">{{row['ApprovedDateMS'] | date:'MM/dd/yyyy HH:mm:ss.SSS'}}</div>
  </div>
}

@if (column.type == 'moved-to-production-user' && row['DateMovedToProductionMS'] != null) {
  <div class="t">
    {{ row[column.name]?.value }}
    <div style="color: rgb(149, 194, 192);">{{row['DateMovedToProductionMS'] | date:'MM/dd/yyyy HH:mm:ss.SSS'}}</div>
  </div>
}

@if (column.type == 'text') {
  <div class="t">
    {{ row[column.name]?.value }}
    @if (column.name == 'RecipeName' && row['SeverityLevel']?.value != null && row['SeverityLevel']?.value == 'Informational') {
      <div style="color: rgb(149, 194, 192);">{{row['SeverityLevel']?.value}}</div>
    }
    @if (column.name == 'RecipeName' && row['SeverityLevel']?.value != null && (row['SeverityLevel']?.value == 'Alarm' || row['SeverityLevel']?.value == 'Critical')) {
      <div style="color: rgb(226, 53, 30);">{{row['SeverityLevel']?.value}}</div>
    }
    @if (column.name == 'RecipeName' && row['SeverityLevel']?.value != null && row['SeverityLevel']?.value == 'Warning') {
      <div style="color: rgb(224, 214, 70);">{{row['SeverityLevel']?.value}}</div>
    }
  </div>
}

@if (column.type == 'email') {
  <div class="t">
    @if (currentSet.tableDisplay?.entityName == 'Person') {
      @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value == 1) {
        {{ row[column.name]?.value }}
      }
      @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value != 1) {
        &nbsp;
      }
    } @else {
      {{ row[column.name]?.value }}
    }
  </div>
}

@if (column.type == 'file-image') {
  <div (click)="viewFile.emit(row[column.name]?.fileImage)" style="cursor:pointer" class="t">
    @if (row[column.name]?.fileImage?.iconFile) {
      <div>
        <img alt="photo" class="photo" [src]="row[column.name]?.fileImage?.iconFile" [title]="row[column.name]?.fileImage?.name" />&nbsp;{{row[column.name]?.fileImage?.name}}
      </div>
    }
    @if (row[column.name]?.fileImage?.thumbnailImage) {
      <div>
        <img alt="photo" class="photo" [src]="row[column.name]?.fileImage?.thumbnailImage" [title]="row[column.name]?.fileImage?.name" />&nbsp;{{row[column.name]?.fileImage?.name}}
      </div>
    }
    @if (row[column.name]?.fileImage?.thumbnailUrl && !row[column.name]?.fileImage?.thumbnailImage) {
      <div>
        <img alt="photo" class="photo" [src]="row[column.name]?.fileImage?.thumbnailUrl" [title]="row[column.name]?.fileImage?.name" />&nbsp;{{row[column.name]?.fileImage?.name}}
      </div>
    }
  </div>
}

@if (column.type == 'date') {
  <div class="t">
    {{ row[column.name]?.value | date:'MM/dd/yyyy HH:mm:ss.SSS' }}
  </div>
}

@if (column.type == 'boolean') {
  <div class="t">
    @if (row[column.name]?.value == true || row[column.name]?.value === 'true' || row[column.name]?.value === 1 || row[column.name]?.value === '1') {
      <div><span class="true-value">Yes</span></div>
    }
    @if (row[column.name]?.value == false || row[column.name]?.value === 'false' || row[column.name]?.value === 0 || row[column.name]?.value === '0') {
      <div><span class="false-value">No</span></div>
    }
  </div>
}

@if (column.type == 'money') {
  <div class="t">
    {{ row[column.name]?.value | currency }}
  </div>
}

@if (column.name == 'actions' && (currentSet.tableDisplay?.allowModification || currentSet.tableDisplay?.allowDelete)) {
  <div class="t" style="white-space: nowrap !important;">
    @if (currentSet.tableDisplay?.entityName == 'Security.iOPSUser' || currentSet.tableDisplay?.entityName == 'Person') {
      @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value == 1) {
        <button style="z-index: 1" class="btn btn-link-icon" title="Edit this record." type="button" (click)="editRecord.emit({ row: row, type: 'edit', event: $event, indexReference: rowIndex })">
          <i class="tim-icons icon-pencil"></i>
        </button>
      }
      @if (currentSet.tableDisplay?.allowModification && row['CanEditRecord']?.value != 1) {
        <div style="z-index: 1" class="btn btn-link-icon">&nbsp;</div>
      }
      @if (currentSet.tableDisplay?.allowCopy && row['CanEditRecord']?.value == 1) {
        <button style="z-index: 1;" class="btn btn-link-icon" title="Copy this record." type="button" (click)="copyRecord.emit(row)">
          <i class="tim-icons icon-single-copy-04"></i>
        </button>
      }
      @if (currentSet.tableDisplay?.allowCopy && row['CanEditRecord']?.value != 1) {
        <div style="z-index: 1" class="btn btn-link-icon">&nbsp;</div>
      }
      @if (currentSet.tableDisplay?.allowDelete && row['CanEditRecord']?.value == 1) {
        <button class="btn btn-link-icon" title="Delete this record." type="button" (click)="deleteRecord.emit(row)">
          <i class="tim-icons danger-color icon-simple-remove"></i>
        </button>
      }
      @if (currentSet.tableDisplay?.allowDelete && row['CanEditRecord']?.value != 1) {
        <div style="z-index: 1" class="btn btn-link-icon">&nbsp;</div>
      }
    } @else {
      @if (currentSet.tableDisplay?.allowModification) {
        <button style="z-index: 1" class="btn btn-link-icon" title="Edit this record." type="button" (click)="editRecord.emit({ row: row, type: 'edit', event: $event, indexReference: rowIndex })">
          <i class="tim-icons icon-pencil"></i>
        </button>
      }
      @if (currentSet.tableDisplay?.allowCopy) {
        <button style="z-index: 1;" class="btn btn-link-icon" title="Copy this record." type="button" (click)="copyRecord.emit(row)">
          <i class="tim-icons icon-single-copy-04"></i>
        </button>
      }
      @if (currentSet.tableDisplay?.hasFileImageTable) {
        <button mat-button style="border:none;z-index: 1" class="btn btn-link-icon" type="button" (click)="fileUploadRecord.emit({ row: row, event: $event, indexReference: rowIndex })"
          title="View uploaded files that were related to this {{currentSet.tableDisplay?.entityName}}. {{ row['CountOfFilesUploaded']?.value > 0 ? row['CountOfFilesUploaded']?.value + ' file' + (row['CountOfFilesUploaded']?.value > 1 ? 's' : '') + ' uploaded currently.' : 'No files uploaded currently.' }}">
          <i [ngClass]="{ 'object-contains-files': row['CountOfFilesUploaded']?.value >= 1 }" class="tim-icons icon-notes clipboard-larger" aria-hidden="true" style="cursor: pointer"></i>
        </button>
      }
      @if (currentSet.tableDisplay?.allowDelete) {
        <button class="btn btn-link-icon" title="Delete this record." type="button" (click)="deleteRecord.emit(row)">
          <i class="tim-icons danger-color icon-simple-remove"></i>
        </button>
      }
    }
  </div>
}